import { CHART_COLORS, chartColorAt } from "./chartColors";

export const PIE_BASE_COLORS = CHART_COLORS;

export const PORTFOLIO_ALLOCATION_COLOR_BY_ID = {
  DSDOMEQ: CHART_COLORS[0],
  DSFIXINC: CHART_COLORS[1],
  DSPRIVEQ: CHART_COLORS[2],
  DSPRIVCRE: CHART_COLORS[3],
  DSINTEQ: CHART_COLORS[4],
  DSREALEST: CHART_COLORS[5],
};

export function colorForAllocationSlice(id, index = 0) {
  if (id != null && id !== "") {
    const key = String(id).trim().toUpperCase();
    const mapped = PORTFOLIO_ALLOCATION_COLOR_BY_ID[key];
    if (mapped) {
      return mapped;
    }
  }
  return chartColorAt(index);
}

export function colorForAllocationId(id) {
  return colorForAllocationSlice(id, 0);
}
